import React from 'react';

export default function IconEarnings() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2545_9831)">
        <g clipPath="url(#clip1_2545_9831)">
          <path
            d="M2.83521 10.8801C2.83521 13.7335 5.14761 14.9003 8.00098 14.9003C10.8544 14.9003 13.1668 13.7335 13.1668 10.8801C13.1668 8.02671 10.8544 4.55811 8.00098 4.55811C5.14761 4.55811 2.83521 8.02671 2.83521 10.8801Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.12494 4.73842H9.14615L10.2493 2.77606C10.61 2.13962 10.2387 1.32285 9.5068 1.20617C9.11433 1.14253 8.61579 1.1001 7.98995 1.1001C7.36412 1.1001 6.86557 1.14253 6.4731 1.20617C5.7518 1.32285 5.36994 2.12901 5.73059 2.77606L6.83375 4.73842H6.85497"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.34985 11.304L7.12128 9.53262L8.8821 10.7206L10.6535 8.94922"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2545_9831">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_2545_9831">
          <rect
            width="15.5"
            height="15.5"
            fill="white"
            transform="translate(0.25 0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
